export default "__VITE_ASSET__Do1q7yQF__"